/** 0 = 1:1，1 = 9:16 */
export type FullscreenType = 0 | 1;

export interface VapOutputDimensions {
  outputWidth: number;
  outputHeight: number;
  /** 先按正方形渲染，再居中裁剪 */
  renderSize: number;
}

/** fixed 相机世界坐标视口（原点在底部中心） */
export interface FixedCameraBounds {
  offsetX: number;
  offsetY: number;
  width: number;
  height: number;
}

export function normalizeFullscreenType(
  value?: number | null,
): FullscreenType {
  return value === 1 ? 1 : 0;
}

export function getFullscreenTypeLabel(
  fullscreenType?: number | null,
): string {
  return normalizeFullscreenType(fullscreenType) === 1 ? "9:16" : "1:1";
}

/**
 * 预览 / 导出共用的 fixed 视口。
 * - 1:1：512×512（历史约定）
 * - 9:16：zip 仍是 1:1，资源坐标系为 912×912；出 avatar 时再居中裁成 9:16
 */
export function getFixedCameraBounds(
  fullscreenType?: number | null,
): FixedCameraBounds {
  if (normalizeFullscreenType(fullscreenType) === 1) {
    return { offsetX: -456, offsetY: 0, width: 912, height: 912 };
  }
  return { offsetX: -256, offsetY: 0, width: 512, height: 512 };
}

export function getVapOriginalDimensions(
  fullscreenType?: number | null,
): VapOutputDimensions {
  if (normalizeFullscreenType(fullscreenType) === 1) {
    // 先按 912 正方形渲染，再居中裁 512×912
    return { outputWidth: 512, outputHeight: 912, renderSize: 912 };
  }
  return { outputWidth: 512, outputHeight: 512, renderSize: 512 };
}

export function getVapPreviewDimensions(
  fullscreenType?: number | null,
): VapOutputDimensions {
  if (normalizeFullscreenType(fullscreenType) === 1) {
    // 与原图同比例：912 * (304/512) = 544
    return { outputWidth: 304, outputHeight: 544, renderSize: 544 };
  }
  return { outputWidth: 304, outputHeight: 304, renderSize: 304 };
}

/** 从 1:1 正方形画布居中裁剪为 9:16（或任意目标尺寸） */
export function cropCenterFromSquare(
  squareCanvas: HTMLCanvasElement,
  outputWidth: number,
  outputHeight: number,
): HTMLCanvasElement {
  const size = squareCanvas.width;
  const x = Math.round((size - outputWidth) / 2);
  const y = Math.round((size - outputHeight) / 2);
  const out = document.createElement("canvas");
  out.width = outputWidth;
  out.height = outputHeight;
  const ctx = out.getContext("2d")!;
  ctx.drawImage(
    squareCanvas,
    x,
    y,
    outputWidth,
    outputHeight,
    0,
    0,
    outputWidth,
    outputHeight,
  );
  return out;
}
